import { apiClient } from "@/api/client";

export type AppKind = "RIDER" | "DRIVER";

/** One row per app. Android and iOS share the version number — only the store link differs. */
export interface AppVersion {
  app: AppKind;
  /** The build number the stores currently carry (the "+N" in pubspec). Null until first set. */
  latestBuildNumber: number | null;
  /** True: everyone below the latest version is blocked until they update. False: an optional prompt. */
  forceUpdate: boolean;
  releaseNotes: string;
  androidStoreUrl: string;
  iosStoreUrl: string;
  updatedBy: string | null;
  updatedByName: string | null;
  updatedAt: string | null;
}

export interface AppVersionRelease {
  id: string;
  buildNumber: number;
  forceUpdate: boolean;
  releaseNotes: string;
  releasedAt: string;
}

export interface AppVersionInput {
  latestBuildNumber: number;
  forceUpdate: boolean;
  releaseNotes?: string;
  androidStoreUrl?: string;
  iosStoreUrl?: string;
}

/** Talks to admin-service's app-version endpoints (see app-version.controller.ts). */
export const appVersionsApi = {
  /** GET /admin/app-versions — always both apps. */
  list: () => apiClient.get<AppVersion[]>("/admin/app-versions").then((r) => r.data),

  /** GET /admin/app-versions/:app/history — past releases, newest first. */
  history: (app: AppKind) =>
    apiClient.get<AppVersionRelease[]>(`/admin/app-versions/${app}/history`).then((r) => r.data),

  /** PUT /admin/app-versions/:app — ADMIN/OPERATIONS only. */
  update: (app: AppKind, payload: AppVersionInput) =>
    apiClient.put<AppVersion>(`/admin/app-versions/${app}`, payload).then((r) => r.data),
};
